<template>
  <v-container>
    <v-card>
      <v-card-title>
        <!-- Toggle between Sign In and Sign Up -->
        <v-btn-toggle v-model="formType" mandatory>
          <v-btn value="signIn">Sign In</v-btn>
          <v-btn value="signUp">Sign Up</v-btn>
        </v-btn-toggle>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('closeModal')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <!-- Sign In Form -->
        <v-form v-if="formType === 'signIn'" @submit.prevent="signIn">
          <v-text-field
            v-model="signInData.email"
            label="Email"
            type="email"
            required
          ></v-text-field>
          <v-text-field
            v-model="signInData.password"
            label="Password"
            type="password"
            required
          ></v-text-field>
          <v-btn type="submit" @click="signIn" color="primary">Sign In</v-btn>
        </v-form>

        <!-- Sign Up Form -->
        <v-form v-else @submit.prevent="signUp">
          <v-text-field
            v-model="signUpData.email"
            label="Email"
            type="email"
            required
          ></v-text-field>
          <v-text-field
            v-model="signUpData.password"
            label="Password"
            type="password"
            required
          ></v-text-field>
          <v-btn type="submit" @click="signUp" color="primary">Sign Up</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";

const auth = getAuth();
export default {
  data() {
    return {
      formType: "signIn", // Toggle between 'signIn' and 'signUp'
      signInData: {
        email: "",
        password: "",
      },
      signUpData: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    signIn() {
      signInWithEmailAndPassword(
        auth,
        this.signInData.email,
        this.signInData.password
      )
        .then(() => {
          this.$emit("authSuccess");
          this.$emit("closeModal");
        })
        .catch((error) => {
          console.error("Error signing in: ", error);
        });
    },
    signUp() {
      createUserWithEmailAndPassword(
        auth,
        this.signUpData.email,
        this.signUpData.password
      )
        .then(() => {
          this.$emit("authSuccess");
          this.$emit("closeModal");
        })
        .catch((error) => {
          console.error("Error signing up: ", error);
        });
    },
  },
};
</script>
